"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isBreakpoint = require("../../utils/is-breakpoint");
var _useWindowWidth = _interopRequireDefault(require("../../utils/use-window-width"));
var _util = require("./util");
var _sbuxCup = _interopRequireDefault(require("./sbux-cup"));
var _holidayCup = _interopRequireDefault(require("./holiday-cup"));
var _xylo = _interopRequireDefault(require("./assets/xylo.mp3"));
require("./spilled-coffee-canvas.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * An interactive element with intention to surprise and delight all users. Built using the `<canvas>` HTML5 element. Users can mouse-over or use a touch screen to "mop up" the spilled beverage to reveal a message underneath. For keyboard and screen reader users, moving focus to the `<canvas>` makes a button visable and focusable. Clicking the button clears the "spill" with a small sound effect, then moving focus to the content underneath. This component is intended primarily for 404 pages.
 *
 * This component includes an mp3 file that may need to be adjusted for in your project. See PropTypes for details.
 */

var SpilledCoffeeCanvas = function SpilledCoffeeCanvas(_ref) {
  var instructions = _ref.instructions,
    spillColor = _ref.spillColor,
    imageDescription = _ref.imageDescription,
    className = _ref.className,
    hiddenContent = _ref.hiddenContent,
    _ref$eraseDiameter = _ref.eraseDiameter,
    eraseDiameter = _ref$eraseDiameter === void 0 ? 20 : _ref$eraseDiameter,
    cleanUpSound = _ref.cleanUpSound,
    _ref$holidayCup = _ref.holidayCup,
    holidayCup = _ref$holidayCup === void 0 ? false : _ref$holidayCup,
    _ref$cupClass = _ref.cupClass,
    cupClass = _ref$cupClass === void 0 ? '' : _ref$cupClass;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    canvas = _useState2[0],
    setCanvas = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    ctx = _useState4[0],
    setCtx = _useState4[1];
  var canvasRef = (0, _react.useCallback)(function (canvasDomEl) {
    if (canvasDomEl !== null) {
      setCanvas(canvasDomEl);
      setCtx(canvasDomEl.getContext('2d'));
    }
  }, []);
  var isMobileWidth = (0, _isBreakpoint.isMobileBreakpoint)((0, _useWindowWidth["default"])());
  (0, _react.useEffect)(function () {
    if (canvas && ctx) {
      (0, _util.drawSpill)({
        ctx: ctx,
        isMobileWidth: isMobileWidth,
        color: spillColor
      });
      var mopping = function mopping(e) {
        (0, _util.handleMopUp)({
          e: e,
          ctx: ctx,
          eraseDiameter: eraseDiameter
        });
      };
      canvas.addEventListener('pointermove', mopping);
      canvas.addEventListener('touchmove', mopping);
      canvas.addEventListener('mousedown', function (e) {
        // prevent clicking from bringing focus to the canvas and showing button
        e.preventDefault();
      });
      return function () {
        canvas.removeEventListener('pointermove', mopping);
        canvas.removeEventListener('touchmove', mopping);
        canvas.removeEventListener('mousedown', function (e) {
          return e.preventDefault();
        });
      };
    }
  }, [canvas]);
  var _useState5 = (0, _react.useState)(instructions),
    _useState6 = _slicedToArray(_useState5, 2),
    ariaLabel = _useState6[0],
    setAriaLabel = _useState6[1];
  var rectWidth = 0;
  var _clearSpill = function clearSpill() {
    if (ctx && rectWidth < canvas.width) {
      ctx.clearRect(rectWidth, 0, 5, canvas.height);
      rectWidth += 5;
      setTimeout(function () {
        _clearSpill();
      }, 15);
    } else {
      setAriaLabel(hiddenContent);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "spillAndCupContainer flex ".concat(className || '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-relative spillWrapper"
  }, /*#__PURE__*/_react["default"].createElement("canvas", {
    "aria-label": imageDescription,
    className: "position-absolute canvas",
    height: isMobileWidth ? 140 : 196,
    ref: canvasRef,
    role: "image",
    width: isMobileWidth ? 280 : 390
  }), /*#__PURE__*/_react["default"].createElement("button", {
    "aria-label": ariaLabel,
    "aria-live": "polite",
    className: "text-bold text-md position-absolute hiddenContent",
    disabled: ariaLabel === hiddenContent,
    onClick: function onClick() {
      var chime = new Audio(cleanUpSound !== null && cleanUpSound !== void 0 ? cleanUpSound : _xylo["default"]);
      chime.addEventListener('canplaythrough', function () {
        chime.play();
      });
      _clearSpill();
    },
    tabIndex: 0
  }, hiddenContent)), holidayCup ? /*#__PURE__*/_react["default"].createElement(_holidayCup["default"], {
    className: "cup ".concat(cupClass)
  }) : /*#__PURE__*/_react["default"].createElement(_sbuxCup["default"], {
    className: "cup ".concat(cupClass)
  }));
};
SpilledCoffeeCanvas.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Describe to screenreader users how the component looks visually. Is the aria-label for the `<canvas>` element.
   */
  imageDescription: _propTypes["default"].string,
  /**
   * Applied to outtermost parent div
   */
  className: _propTypes["default"].string,
  /**
   * Diameter for "mopping" to occurd for all device types.
   */
  eraseDiameter: _propTypes["default"].number,
  /**
   * String that is hidden underneath spill, revealed when spill is cleaned up.
   */
  hiddenContent: _propTypes["default"].string,
  /**
   * You can optionally render the cup as a Starbucks Red Cup during holidays.
   */
  holidayCup: _propTypes["default"].bool,
  /**
   * If you'd like to add classes to the cup itself
   */
  cupClass: _propTypes["default"].string,
  /**
   * Screen reader instructions to interact with component. Set as aria-label on hidden content button.
   */
  instructions: _propTypes["default"].string,
  /**
   * The color of the spill in hash format. Should be reflective of a Starbucks beverage.
   */
  spillColor: _propTypes["default"].string,
  /**
   * A sound, powered by JavaScript's Audio API. You'll need to add the file type to your bundler so it can read it. If using Webpack, `file-loader` will load mp3s.
   */
  cleanUpSound: _propTypes["default"].any
} : {};
SpilledCoffeeCanvas.displayName = 'SpilledCoffeeCanvas';
var _default = exports["default"] = SpilledCoffeeCanvas;